//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('accountingAllocationLine', {
//        templateUrl: 'views/components/views/accountingAllocationLine/accountingAllocationLine.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'translateService', 'modalService', 'accountingAllocationLineService', 'logisticService', 'typeaheadService', function ($stateParams, stateService, utilityService, translateService, modalService, accountingAllocationLineService, logisticService, typeaheadService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let accountingAllocationKeyno = $stateParams.accountingallocation_keyno;
//            let accountingAllocationLineKeyno = $stateParams.accountingallocationline_keyno;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                departmentButtons: [
//                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.model.edit.department_id = '' }
//                ],
//                edit: {},
//                selectListDepartments: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATE SERVICE

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATE SERVICE

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await accountingAllocationLineService.getEdit({
//                    accountingallocation_keyno: accountingAllocationKeyno,
//                    accountingallocationline_keyno: accountingAllocationLineKeyno
//                }))[0];

//                return loadDepartments();
//            }

//            async function loadDepartments() {
//                if (utilityService.validateParmsValue(vm.model.edit.businessco_no) !== true) return;

//                return vm.model.selectListDepartments = await logisticService.listDepartment({ businessco_no: vm.model.edit.businessco_no });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region TYPEAHEAD SEARCH SINGLE PROCEDURE FUNCTION CALL

//            vm.typeaheadSearch = function (value, id) {
//                switch (id) {
//                    case 'project_name':
//                        vm.model.edit[id] = value;

//                        return typeaheadService.lookUpSearchProjects({
//                            project_name: vm.model.edit[id] || '',
//                            businessco_no: vm.model.edit.businessco_no
//                        });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion TYPEAHEAD SEARCH SINGLE PROCEDURE FUNCTION CALL

//            // #region SELECTED VALUE FUNCTION

//            vm.onTypeaheadSelected = function (item, id) {
//                switch (id) {
//                    case 'project_name':
//                        if (item) {
//                            vm.model.edit.project_keyno = item?.item_id ?? '0';
//                            vm.model.edit.project_name = item?.item_name ?? '';
//                        } else {
//                            vm.onTypeaheadClear('project_name');
//                        }
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion SELECTED VALUE FUNCTION

//            // #region CHANGED VALUE FUNCTION

//            vm.onTypeaheadChanged = function (value, item, id) {
//                switch (id) {
//                    case 'project_name':
//                        vm.model.edit.project_name = value;

//                        if (value) {
//                            if (item?.item_id) {
//                                vm.model.edit.project_keyno = item.item_id;
//                            }
//                        } else {
//                            vm.onTypeaheadClear('project_name');
//                        }
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion CHANGED VALUE FUNCTION

//            // #region CLEAR VALUE FUNCTION

//            vm.onTypeaheadClear = function (id) {
//                switch (id) {
//                    case 'project_name':
//                        vm.model.edit.project_keyno = '0';
//                        vm.model.edit.project_name = '';
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion CLEAR VALUE FUNCTION

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                accountingAllocationLineService.saveObj(vm.model.edit).then((response) => {
//                    if (response[0] && response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                    		title: translations.error,
//                    		message: response[0].errormessage,
//                    		buttons: [{
//                    			label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: (dialogItself) => {
//                    				dialogItself.close();
//                    				vm.model.lockedSave = false;
//                    			}
//                    		}]
//                    	});
//                    } else {
//                    	vm.model.lockedSave = false;
//                    	stateService.back();
//                    }
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//            	loadEdit();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
